import { useUndismissEngagement } from './useUndismissEngagement'

type UseUndismissMentionResult = {
  undismissMention: (mentionId: string) => Promise<boolean>
  loading: boolean
}

/**
 * Mention-specific specialization over `useUndismissEngagement`. Hardcodes
 * `engagementType: 'mention'` so call sites stay readable
 * (`undismissMention(mention.id)` instead of the kind-agnostic shape).
 *
 * Sibling of `useDismissMention`. When comments migrates off the legacy
 * `undismissComment` mutation, mirror this file as `useUndismissComment` —
 * same wrapper pattern, swap the engagementType.
 */
export const useUndismissMention = (): UseUndismissMentionResult => {
  const { undismissEngagement, loading } = useUndismissEngagement()

  const undismissMention = (mentionId: string): Promise<boolean> =>
    undismissEngagement({
      engagementId: mentionId,
      engagementType: 'mention',
    })

  return { undismissMention, loading }
}
